// src/project/data/triggers/buyProduct.js
import { buildActionUrl, RIDER_ENDPOINTS, getUserId } from '../config/apiConfig'

export default {
  postUrl() {
    // Endpoint V3 — Réserver un produit : POST /product/create/buying
    return buildActionUrl(RIDER_ENDPOINTS.PRODUCT_BUY)
  },
  format(params) {
    // V3 : Le body inclut userId, productId et quantity (pas de deliveryAddress)
    return {
      userId: getUserId(),
      productId: params.productId,
      quantity: params.quantity || 1,
    }
  },
  parse(raw = {}) {
    // Réponse V3 attendue :
    // { statusCode: 201, message: "Reserved", data: { id (buyingId), userId, productId, status: "pending", totalPrice, ... } }
    if (raw?.statusCode !== 200 && raw?.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || "Erreur lors de la réservation du produit",
        data: null,
        isDisplayable: raw?.isDisplayable || false,
      }
    }
    return {
      statusCode: 200,
      message: raw?.message || 'Produit réservé avec succès',
      data: raw?.data || null,
      // Le buyingId est nécessaire pour le paiement
      buyingId: raw?.data?.id || null,
    }
  },
}
